<template>
<div class="chapter">
<div class="inner_page">
<p class="cpytxt2"><span><a id="page_iv">Copyright © 2012 by T.J. Murphy</a></span></p><a id="page_iv">
<p class="cpytxt"><span>CrossFit<sup>®</sup> is a registered trademark of CrossFit, Inc.</span></p>
<p class="cpytxt1"><span>All rights reserved. Published in the United States of America by VeloPress, a division of Competitor Group, Inc.</span></p>
<p class="cpytxt3"><span><img alt="images" src="images/logo.jpg"/></span></p>
<p class="cpytxt"><span>3002 Sterling Circle, Suite 100</span></p>
<p class="cpytxt"><span>Boulder, Colorado 80301-2338 USA</span></p>
</a><p class="cpytxt"><a id="page_iv"><span>(303) 440-0601 · Fax (303) 444-6788 · E-mail </span></a><a href="mailto:velopress@competitorgroup.com">velopress@competitorgroup.com</a></p>
<p class="cpytxt3"><span>Distributed in the United States and Canada by Ingram Publisher Services</span></p>
<p class="cpytxt1"><span>A Cataloging-in-Publication record for the printed edition is available from the Library of Congress.</span></p>
<p class="cpytxt"><span>ISBN 978-1-934030-90-5 (pbk.: alk. paper); ISBN 978-1-937716-21-9 (e-book)</span></p>
<p class="cpytxt1"><span>For information on purchasing VeloPress books, please call (800) 811-4210 ext. 2138 or visit <a href="http://www.velopress.com" target="_blank">www.velopress.com</a>.</span></p>
<p class="cpytxt3"><span>Cover design by <i>the</i>BookDesigners</span></p>
<p class="cpytxt"><span>Cover photograph by Nick Rudnicki</span></p>
<p class="cpytxt"><span>Interior design by Erin Johnson</span></p>
<p class="cpytxt"><span>Interior photographs by Robert Murphy, Scott Draper, and Caroline Treadway</span></p>
<p class="cpytxt3"><span>V.3.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?573aa1ee